export default {
      id: "lock-usage",
      viewBox: "0 0 16 18",
      url: __webpack_public_path__ + "img/icons.f759dcb6.svg#lock",
      toString: function () {
        return this.url;
      }
    }